import { MenuAction } from "@inductiveautomation/ws-components";
import { TFunction } from "i18next";

import { MakerLicenseSummaryItem } from "./api/makerLicenses.api";

export const licenseActions =
  (t: TFunction, onAction: (actionId: string, licenseIds: string[]) => void) =>
  (_license: MakerLicenseSummaryItem): MenuAction[][] => {
    const generateActivationToken = {
      id: "generate-activation-token",
      label: t("maker_licenses.actions.generate_activation_token.label"),
      iconLeft: "license-transfer-outlined" as const,
      bulkAction: false,
      onClick: onAction,
    };

    const deleteAction = {
      id: "delete",
      label: t("maker_licenses.actions.delete.label"),
      iconLeft: "delete-outlined" as const,
      iconLeftVariant: "destructive" as const,
      onClick: onAction,
    };

    return [[generateActivationToken], [deleteAction]];
  };
